import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './routes/index'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'popper.js/dist/popper.min.js';
import 'jquery/src/jquery.js'
/* import '@/assets/js/swiper-bundle.min.js' */
import '@/assets/js/custom.js'


Vue.config.productionTip = false
Vue.use(Vuex)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
